module.exports = __webpack_public_path__ + "static/img/tomato-paste.0e77665.svg";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/tomato-paste.svg
// module id = 3HqO
// module chunks = 1